module.exports = __webpack_public_path__ + "static/media/slide1.a1dd7fc2.jpg";